import { EmailVerifyPage } from '@/modules/email-verify/components/page';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(EmailVerifyPage);

export const roles: string[] = [];
export const path = '/email-verify';
export const element = <AnimatedPage />